import { defineMessages } from 'react-intl';

export const dictationMessages = defineMessages({
  genericError: {
    defaultMessage: 'Sorry there was an error',
    id: 'YGR6rRXa08',
    description:
      'Fallback toast title shown when dictation fails without a specific error',
  },
  tryAgainOrContactSupport: {
    defaultMessage: 'Please try again later or contact support',
    id: 'P9bxBo80sH',
    description: 'Toast description shown when dictation fails',
  },
  cleanupFailed: {
    defaultMessage: "Couldn't tidy your dictation. Your original text was kept.",
    id: 'SjLxnHxu3l',
    description:
      'Toast shown when the dictation clean-up request fails and the raw dictated text stays in the note',
  },
  cleanupInterrupted: {
    defaultMessage:
      "Couldn't finish tidying your dictation. Check the text before you continue.",
    id: 'N2fZny50Uz',
    description:
      'Toast shown when the dictation clean-up stream fails after it has started replacing the dictated text, so the note holds partly tidied text',
  },
});
